type ProductPreviewFrameProps = {
  children: React.ReactNode;
  title: string;
  badge?: string;
  className?: string;
};

export function ProductPreviewFrame({
  children,
  title,
  badge,
  className = "",
}: ProductPreviewFrameProps) {
  return (
    <div
      className={`sh-card-elevated overflow-hidden ${className}`}
      aria-label={`${title} product preview`}
    >
      <div className="flex items-center gap-2 border-b border-white/10 bg-black/30 px-4 py-2.5">
        <div className="flex gap-1.5" aria-hidden>
          <span className="h-2.5 w-2.5 rounded-full bg-white/20" />
          <span className="h-2.5 w-2.5 rounded-full bg-white/20" />
          <span className="h-2.5 w-2.5 rounded-full bg-white/20" />
        </div>
        <p className="min-w-0 flex-1 truncate text-center text-[11px] font-medium text-white/50">
          {title}
        </p>
        {badge ? (
          <span className="rounded-full border border-brand/30 bg-brand/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-brand">
            {badge}
          </span>
        ) : (
          <span className="w-14" aria-hidden />
        )}
      </div>
      <div className="bg-surface">{children}</div>
      <p className="border-t border-white/10 px-4 py-2 text-[11px] text-white/40">
        Illustrative sample data — your model uses your real inputs.
      </p>
    </div>
  );
}
